import {Fragment, useEffect} from "react"
import {useRenderableDataStore} from "../common/hooks/useRenderableDataStore";
import {SelectOption} from "../common/CommonUIElementTypes";
import {ApiUtility} from "../common/ApiUtility";
import {DateUtility} from "../common/DateUtility";
import {LoadingIndicator} from "../common/LoadingIndicator";

interface BrokerAssignmentCountInfoProps {
    selectedBrokerOption: SelectOption;
    date: Date;
    knownAssignedTruckCount: number;
    dispatchOrderId: number;
}

export let BrokerAssignmentCountInfo = function (props: BrokerAssignmentCountInfoProps) {
    let dataStore = useRenderableDataStore({
        loading: false,
        assignedTruckCount: 0,
        totalTruckCount: 0,
        unlimitedTrucks: false,
    })

    useEffect(() => {
        dataStore.updateAndRender({loading: true,});
        ApiUtility.getBrokerAssignmentCountForDate(
            props.selectedBrokerOption.value as number,
            DateUtility.jsDateToURLDate(props.date),
            props.dispatchOrderId
        )
            .then((assignmentCountData: any) => {
                dataStore.updateAndRender({
                    loading: false,
                    assignedTruckCount: assignmentCountData.assigned_truck_count,
                    totalTruckCount: assignmentCountData.total_truck_count,
                    unlimitedTrucks: assignmentCountData.unlimited_trucks,
                });
            })
            .catch((error) => {
                dataStore.updateAndRender({loading: false});
                console.error('Error fetching broker assignment count for date', error);
            })
    }, [props.selectedBrokerOption.value, props.date]);

    return (
        <div className="broker-assignment-count-info">
            {(() => {
                if (dataStore.data().loading) {
                    return <LoadingIndicator/>
                } else {
                    let assignedCount = (parseInt('' + dataStore.data().assignedTruckCount) || 0) + (parseInt('' + props.knownAssignedTruckCount) || 0)
                    return (
                        <div className="broker-assignment-count-info-content">
                            <div className="broker-assignment-count-broker-name">
                                {props.selectedBrokerOption.label}
                            </div>
                            <div className="broker-assignment-count-value">
                                {dataStore.data().unlimitedTrucks
                                    ? <Fragment>
                                        {assignedCount + '/'}
                                        <img className="broker-assignment-count-unlimited-icon" src="/static/images/infinity-textcolor.svg" alt="Unlimited"/>
                                        {' Assigned'}
                                    </Fragment>
                                    : assignedCount + '/' + dataStore.data().totalTruckCount + ' Assigned'}
                            </div>
                        </div>
                    )
                }
            })()}
        </div>
    )
}
